import { Box, Grid, Typography, Link } from "@mui/material";
import React from "react";
import Logo from "../../assets/images/StyLogo.png";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import API from "../../utils/Axios.utils";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Notification } from "../../utils/Notification";

const ForgotPassword = () => {
  const navigate = useNavigate();

  // Snackbar
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const handleAlert = () => {
    setAlert(false);
  };

  const ForgetPassSchema = Yup.object().shape({
    email: Yup.string()
      .email("Email must be a valid email address.")
      .trim()
      .matches(
        /^[\w-.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
        "Email must be a valid email address."
      )
      .required("Email is required."),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: ForgetPassSchema,
    onSubmit: async () => {
      await handleRequest(formik);
    },
  });

  const handleRequest = async (formik) => {
    console.log("i am clicked");
    const dataa = {
      email: formik.values.email,
    };
    console.log(dataa);
    await API.post("/api/users/forget_password", dataa)
      .then((res) => {
        localStorage.setItem("token", res?.data?.token);
        // navigate("/emailconfirmation");
        setAlertContent(res?.data?.message);
        setAlertType("success");
        setAlert(true);
      })
      .catch((error) => {
        // console.log(err?.response?.data?.message);
        setAlertContent(
          error?.response?.data?.message ||
          "An error occurred. Please try again later."
        );
        setAlertType("error");
        setAlert(true);
      });
  };

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } =
    formik;

  return (
    <Grid className="global_bg" style={{ height: "100vh" }}>
      <Grid
        container
        className="global_text"
        justifyContent="center"
        p="10%"
        gap="20px"
        align="center"
        direction="column"
      >
        <Grid item>
          <img src={Logo} width={300} height={80} alt="logo" />
          <Typography>
            <h2>Forgot password?</h2>
          </Typography>

          <Typography sx={{ maxWidth: "410px" }}>
            Enter the registered email to get the reset password link
          </Typography>

          <Grid sx={{ p: 3 }}>
            <FormikProvider value={formik}>
              <Form
                autoComplete="off"
                noValidate
                onSubmit={handleSubmit}
                style={{ maxWidth: "350px" }}
              >
                <TextField
                  fullWidth
                  size="small"
                  autoComplete="username"
                  type="email"
                  placeholder="Enter email"
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
                <Grid sx={{ mt: 4 }}>
                  <Button variant="contained" type="submit">
                    SEND
                  </Button>
                </Grid>
              </Form>
            </FormikProvider>
          </Grid>
          <Link
            className="login-text-color"
            variant="subtitle2"
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/", { replace: true })}
          >
            <Button variant="text" mt="0px">
              <NavigateBeforeIcon /> Back to Login
            </Button>
          </Link>
        </Grid>
      </Grid>
      <Notification
        message={alertContent}
        open={alert}
        severity={alertType}
        onClose={handleAlert}
      />
      {/* </Box> */}
    </Grid>
  );
};

export default ForgotPassword;
